import React from 'react'
import PropTypes from 'prop-types'
import FormHOC from './FormHOC'
import InputRow from '../elements/InputRow'
import Button from '../elements/Button'
import InputRowReadOnly from '../elements/InputRowReadOnly'
import Addressify from '../elements/Addressify'
import InputRowPaymentMethod from '../components/InputRowPaymentMethod'
import FancySelectAdvancedRow from '../elements/FancySelectAdvancedRow'

const options = {
    postUrl: '/api/postReplaceSim',
    success: 'Success! Your replacement SIM card is on its way.'
}
const state = {
    name: '',
    address: '',
    serviceId: '',
    simType: '3IN1',
    deliveryEmail: '',
}

class ReplaceSimForm extends React.Component {
    componentDidMount () {
        this.props.setDynamicValues({
            serviceId: this.props.serviceId
        })
    }

    render () {
        return (
            <form onSubmit={this.props.handleSubmit} onKeyDown={this.props.handleKeyDown}>
                <InputRowReadOnly
                    label='My mobile number'
                    value={this.props.serviceNo}
                />
                <InputRowReadOnly
                    label='Replacement SIM price'
                    value={this.props.values.simType === 'ESIM' ? '$0': '$10.00 + Free shipping'}
                />

                <FancySelectAdvancedRow
                    className='select-no-label'
                    options={[
                        {
                            label: '3-IN-1 (fits all devices)',
                            value: '3IN1'
                        },
                        {
                            label: 'eSIM',
                            value: 'ESIM'
                        }
                    ]}
                    value='3IN1'
                    label='Replacement SIM type'
                    name='simType'
                    errors={this.props.errors}
                    handleChange={this.props.setDynamicValues}
                />
                <InputRowPaymentMethod />
                <InputRow
                    label='Delivery recipient'
                    name='name'
                    value={this.props.values.name}
                    errors={this.props.errors}
                    handleChange={this.props.handleInputChange}
                    placeholder='Name of person accepting delivery'
                />
                {this.props.values.simType !== 'ESIM'
                    ?
                        <Addressify
                        label='Delivery address'
                        value={this.props.values.address}
                        errors={this.props.errors}
                        handleSetAddress={this.props.setDynamicValues}
                        placeholder='Start typing your delivery address'
                    >
                        <small>We can't deliver to PO Box</small>

                    </Addressify>
                    :
                    <InputRow
                            label='Delivery email'
                            name='deliveryEmail'
                            value={this.props.values.deliveryEmail}
                            errors={this.props.errors}
                            handleChange={this.props.handleInputChange}
                            placeholder='Email address to send eSIM'
                    />}
                {this.props.children}

                <div className='mt-4'>
                    <Button title='Order SIM' action={this.props.handleSubmit} />
                </div>
            </form>
        )
    }
}

ReplaceSimForm.propTypes = {
    serviceId: PropTypes.number,
    serviceNo: PropTypes.string
}

export default FormHOC(ReplaceSimForm, state, options)



// WEBPACK FOOTER //
// ./resources/js/forms/ReplaceSimForm.js